<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://ebox.stajerski-avtodom.si">ŠAD eRačuni</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Štajerski avto dom d.o.o.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://ebox.stajerski-avtodom.si">ŠAD BI</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
